import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard, Users, DollarSign, Settings, Shield, Search,
  CreditCard, FileText, Store, BarChart3, Bot, Share2, LineChart,
  MessageSquare,
} from 'lucide-react';
import { cn } from '@/lib/utils';

const navGroups = [
  {
    label: '總覽',
    items: [
      { to: '/dashboard', icon: LayoutDashboard, label: '儀表板' },
      { to: '/analytics', icon: LineChart, label: 'GA4 流量分析' },
    ],
  },
  {
    label: '用戶 & 收入',
    items: [
      { to: '/users', icon: Users, label: '用戶管理' },
      { to: '/revenue', icon: DollarSign, label: '收入統計' },
      { to: '/payments', icon: CreditCard, label: '付款紀錄' },
      { to: '/referrals', icon: Share2, label: '推薦分潤' },
    ],
  },
  {
    label: '內容 & 策略',
    items: [
      { to: '/blog', icon: FileText, label: 'Blog 管理' },
      { to: '/strategies', icon: Store, label: '策略審核' },
      { to: '/threads', icon: MessageSquare, label: 'Threads 監控' },
    ],
  },
  {
    label: '交易活動',
    items: [
      { to: '/backtests', icon: BarChart3, label: '回測歷史' },
      { to: '/bots', icon: Bot, label: '交易機器人' },
    ],
  },
  {
    label: '系統',
    items: [
      { to: '/seo', icon: Search, label: 'SEO 分析' },
      { to: '/settings', icon: Settings, label: '系統設定' },
    ],
  },
];

interface SidebarProps {
  onNavClick?: () => void;
}

export function Sidebar({ onNavClick }: SidebarProps) {
  return (
    <aside className="h-full bg-card border-r border-border flex flex-col">
      {/* Logo */}
      <div className="h-14 flex items-center px-4 border-b border-border flex-shrink-0">
        <Shield className="w-6 h-6 text-brand-primary mr-2 flex-shrink-0" />
        <span className="font-bold text-lg truncate">Sentinel 管理</span>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-3 space-y-4 overflow-y-auto">
        {navGroups.map((group) => (
          <div key={group.label}>
            <p className="px-3 mb-1 text-xs font-semibold text-muted-foreground uppercase tracking-wider">
              {group.label}
            </p>
            <div className="space-y-0.5">
              {group.items.map(({ to, icon: Icon, label }) => (
                <NavLink
                  key={to}
                  to={to}
                  onClick={() => onNavClick?.()}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors',
                      isActive
                        ? 'bg-brand-primary/10 text-brand-primary'
                        : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                    )
                  }
                >
                  <Icon className="w-4 h-4 flex-shrink-0" />
                  {label}
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-border flex-shrink-0">
        <p className="text-xs text-muted-foreground">Sentinel Bot v2.0</p>
      </div>
    </aside>
  );
}
